var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 30.9998L15.0834 28.8332C12.2778 26.3054 9.95837 24.1248 8.12504 22.2915C6.29171 20.4582 4.83337 18.8121 3.75004 17.3532C2.66671 15.8954 1.91004 14.5554 1.48004 13.3332C1.04893 12.1109 0.833374 10.8609 0.833374 9.58317C0.833374 6.97206 1.70837 4.7915 3.45837 3.0415C5.20837 1.2915 7.38893 0.416504 10 0.416504C11.4445 0.416504 12.8195 0.722059 14.125 1.33317C15.4306 1.94428 16.5556 2.80539 17.5 3.9165C18.4445 2.80539 19.5695 1.94428 20.875 1.33317C22.1806 0.722059 23.5556 0.416504 25 0.416504C27.6112 0.416504 29.7917 1.2915 31.5417 3.0415C33.2917 4.7915 34.1667 6.97206 34.1667 9.58317C34.1667 10.8609 33.9517 12.1109 33.5217 13.3332C33.0906 14.5554 32.3334 15.8954 31.25 17.3532C30.1667 18.8121 28.7084 20.4582 26.875 22.2915C25.0417 24.1248 22.7223 26.3054 19.9167 28.8332L17.5 30.9998Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.6efec0a9.svg";
export { ForwardRef as ReactComponent };